body > announcement-bar {
  display: block;
  background: var(--color-dark-gray);
  padding-block: .75rem;
  padding-inline: 1rem 5rem;
  font-weight: bold;
  text-align: center;
  color: var(--color-light-orange);

  > a {
    color: var(--color-lightest-orange);
    text-decoration: none;

    > sl-icon {
      vertical-align: -0.15em;
    }
  }
}

body > nav {
  view-transition-name: navbar;
  z-index: 1;
  position: relative;
  margin: var(--sl-spacing-x-large) 0 var(--sl-spacing-large);
  font-weight: 520;
}

@media (max-width: 1023px) {

body > nav {
    margin: var(--sl-spacing-medium) 0;
}
  }

body > nav.edge {
    background: linear-gradient(
      to bottom,
      white 0%,
      rgb(255, 251, 235) 90%,
      white 100%
    );
  }

body > nav a[aria-current] {
    text-decoration-thickness: 5px;
    text-decoration-skip: none;
    text-underline-offset: 0.3em;
  }

body > nav .logo {
    width: 320px;
    margin-top: -45px;
  }

@media (max-width: 1023px) {

body > nav .logo {
      margin-top: -20px;
  }
    }

body > nav sl-button[menutoggle] {
    margin-top: -45px;
  }

body > nav kbd {
    position: absolute;
    margin-left: 0.7rem;
    font-size: 70%;
    font-weight: var(--body-font-weight);
    opacity: 0.5;
  }

navbar-inner,
footer-inner {
  display: block;
  max-width: var(--max-content-width);
  margin: 0 auto;
}

bridgetown-search-form input {
  display: block;
  appearance: none;
  font-family: inherit;
  font-size: 1em;
  font-weight: 520;
  margin-bottom: 0.3em;
  padding: 0.2em 0.6em;
  width: calc(100% - 1.3em);
  background: #fff;
  opacity: 0.5;
  border: 1px solid var(--color-light-gray);
  border-radius: 1em;
  box-shadow: inset 0 0.0625em 0.125em rgba(10, 10, 10, 0.05);
  color: inherit;
}

bridgetown-search-form input:focus,
  bridgetown-search-form input:hover {
    opacity: 1;
  }

@keyframes swingBackAndForth {
  0% {
    transform: rotate(-7deg);
  }
  4.5% {
    transform: rotate(-16deg);
  }
  11.5% {
    transform: rotate(-7deg);
  }
  18% {
    transform: rotate(-10deg);
  }
  25% {
    transform: rotate(-7deg);
  }
  30% {
    transform: rotate(-8deg);
  }
  37% {
    transform: rotate(-7deg);
  }
}

edge-label {
  position: absolute;
  left: 7.3rem;
  top: 4.5rem;
  margin: 0;
  font-size: 0.9rem;
  font-weight: bold;
  transform: rotate(-7deg);
  transform-origin: 99% 2%;
  background: var(--color-orange);
  color: white;
  padding: 0.25em 0.7em;
  border-radius: 4px 2px 4px 4px;
  box-shadow: 0px 11px 6px -7px rgba(0, 0, 0, 0.15);
  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  animation: swingBackAndForth 8s;
  animation-delay: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}

@media (max-width: 1023px) {

edge-label {
    font-size: 0.75rem;
    top: 5.15rem;
    left: 7.75rem;
}
  }

/*# sourceMappingURL=data:application/json;base64,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 */